import { render } from "./UploadHeader_2.component.vue?vue&type=template&id=34b7d184&scoped=true&ts=true"
import script from "./UploadHeader_2.component.vue?vue&type=script&lang=ts"
export * from "./UploadHeader_2.component.vue?vue&type=script&lang=ts"

import "./UploadHeader_2.component.vue?vue&type=style&index=0&id=34b7d184&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/WEAS/WEAS_CI/WEAS_FRONT/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34b7d184"]])

export default __exports__